import { render } from "./CreateUserRecord.vue?vue&type=template&id=0dc3eb14&scoped=true"
import script from "./CreateUserRecord.vue?vue&type=script&lang=js"
export * from "./CreateUserRecord.vue?vue&type=script&lang=js"

import "./CreateUserRecord.vue?vue&type=style&index=0&id=0dc3eb14&scoped=true&lang=css"
import "./CreateUserRecord.vue?vue&type=style&index=1&id=0dc3eb14&lang=css"
import "./CreateUserRecord.vue?vue&type=style&index=2&id=0dc3eb14&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=3&id=0dc3eb14&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc3eb14"]])

export default __exports__